export const NC_FILE_TYPE_OPTIONS = [
  { name: 'Linked', icon: 'linked' },
  { name: 'Change', icon: 'change' },
  { name: 'Setup', icon: 'setup' },
  { name: 'Ignore', icon: 'ignore' },
] as const;
